import { useMutation } from '@tanstack/react-query';

import { postMessageRN } from 'utils/webview.utils';

import { useEmbedded } from 'hooks/useEmbedded';
import { useTicketsClient } from 'services/api';
import { OrderCancelDocument } from 'types/api/tickets.types';

export const useTicketsOrderCancel = () => {
  const ticketsClient = useTicketsClient();
  const { isEmbedded } = useEmbedded();

  const mutation = useMutation({
    mutationFn: (orderId: string) =>
      ticketsClient.request(OrderCancelDocument, {
        orderId,
      }),
    onSuccess: () => {
      if (isEmbedded) {
        postMessageRN({ type: 'orderCancelled' });
      }
    },
  });

  return {
    cancelOrder: mutation.mutate,
    cancelOrderAsync: mutation.mutateAsync,
  };
};
